import './instrument';

import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { environment } from './environments/environment';
import { AmRootModule } from '@am/root.module';

if (environment.enableAngularProdMode) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AmRootModule)
  .catch((err) => console.error(err));
